import React from 'react';

import { StyledMain } from './styled';

const Main = ({ children }: { children: React.ReactNode }) => {
  return <StyledMain>{children}</StyledMain>;
};

export default Main;
